import React from 'react';
import { Box, Inscription } from '@common-fe/common-fe';

interface Props {
  errors: string[];
  testId?: string;
}

export const ErrorZone: React.FC<Props> = ({ errors, testId }) => {
  if (errors.length === 0) return null;

  return (
    <Box direction="column" gap="spacing8" data-testid={testId} margin={{ top: 'spacing24' }}>
      {errors.map((error, index) => (
        <Box key={index} direction="row" justify="end">
          <Inscription 
            color="danger" 
            lineHeight="20px"
            data-testid={testId ? `${testId}_error_${index}` : undefined}
          >
            {error}
          </Inscription>
        </Box>
      ))}
    </Box>
  );
};
